/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __assign } from "tslib";
import { CreateVolumeStreamingBehavior } from '../mol-plugin/behavior/dynamic/volume-streaming/transformers';
import { DefaultPluginSpec } from '../mol-plugin/spec';
import { VolumeStreamingCustomControls } from './custom/volume';
export var DefaultPluginUISpec = function () {
  return __assign(__assign({}, DefaultPluginSpec()), {
    customParamEditors: [[CreateVolumeStreamingBehavior, VolumeStreamingCustomControls]]
  });
};